import messages from "../config/validationMessages"

export const getValidationMessage = (
    messageIndex: keyof typeof messages,
): string => messages[messageIndex] ?? ""
